import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const ActivityRoute: Route = {
  path: 'activity',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/activity.component').then((m) => m.ActivityComponent),
    },
    {
      path: ':activityId',
      loadComponent: () => import('./pages/activity-details.component').then((m) => m.ActivityDetailsComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
